/* sugar:assets/highlight-emoji.js@2.2.0 */
/*
  Highlight Emoji — drops emoji onto the highlighted words of a Heading or Text
  block and starts their animation when the words scroll into view.

  The block renders a marker (data-hle) inside its host; the host is the
  nearest [data-text-block]. Each target word (strong / em / u) becomes a
  positioned span holding N emoji, each placed at a preset offset around the
  word so three magnets arrive from three directions, the way the reference
  page did it. Offsets scale with the Spread setting.
*/
(function () {
  'use strict';
  if (window.__sugarHighlightEmoji) return;
  window.__sugarHighlightEmoji = true;

  /* Where each copy starts (pull), lands (burst) or sits (float / none): em
     units relative to the word's font size, and a tilt. */
  var SPOTS = [
    [-6, -2.2, -28],
    [6.2, -1.8, 26],
    [0.5, -3.4, 8],
    [-3.5, 2.6, 18],
    [4, 2.4, -16],
  ];

  function decorate(marker) {
    if (marker.dataset.hleDone) return;
    marker.dataset.hleDone = '1';
    var host = marker.closest('[data-text-block]');
    if (!host) return;
    var targetTag = marker.dataset.hleTarget || 'strong';
    var content = host.querySelector('.sw-content');
    if (!content) return;
    var words = content.querySelectorAll(targetTag + (targetTag === 'u' ? ', span[style*="underline"]' : ''));
    if (!words.length) return;

    var emojis = (marker.dataset.hleEmoji || '✨').split(/\s+/).filter(Boolean);
    var icons = {};
    marker.querySelectorAll('template[data-hle-icon]').forEach(function (t) {
      icons[t.getAttribute('data-hle-icon')] = t;
    });
    var glow = marker.dataset.hleGlow === 'true';
    var count = Math.max(1, Math.min(5, parseInt(marker.dataset.hleCount, 10) || 3));
    var anim = marker.dataset.hleAnim || 'pull';
    var size = parseFloat(marker.dataset.hleSize) || 0.5;
    var spread = parseFloat(marker.dataset.hleSpread) || 1;
    var repeat = marker.dataset.hleRepeat === 'true';

    var decorated = [];
    words.forEach(function (word) {
      if (word.querySelector('.sugar-highlight-emoji__item')) return;
      word.classList.add('sugar-highlight-emoji__word');
      word.setAttribute('data-hle-anim', anim);
      if (glow) word.setAttribute('data-hle-glow', '');
      for (var i = 0; i < count; i++) {
        var spot = SPOTS[i % SPOTS.length];
        var el = document.createElement('i');
        el.className = 'sugar-highlight-emoji__item';
        el.setAttribute('aria-hidden', 'true');
        var token = emojis[i % emojis.length];
        if (icons[token]) {
          el.className += ' sugar-highlight-emoji__item--icon';
          el.appendChild(icons[token].content.cloneNode(true));
        } else {
          el.textContent = token;
        }
        el.style.setProperty('--hle-x', spot[0] * spread + 'em');
        el.style.setProperty('--hle-y', spot[1] * spread + 'em');
        el.style.setProperty('--hle-r', spot[2] + 'deg');
        el.style.setProperty('--hle-size', size + 'em');
        el.style.setProperty('--hle-delay', (0.35 + i * 0.11).toFixed(2) + 's');
        word.appendChild(el);
      }
      decorated.push(word);
    });
    if (!decorated.length) return;

    // A copy waiting at its start spot, or resting there (float, none, a finished burst), sits up to
    // a few em outside the word and widened the page on phones. Clip the section sideways only, at
    // its own (full) width, so nothing scrolls and the copies still fly in above and below the line.
    var section = host.closest('.shopify-section');
    if (section && getComputedStyle(section).overflowX === 'visible') section.style.overflowX = 'clip';

    // The words are on screen from the first paint, but this runs with the other deferred
    // scripts, right before the sliders mount and the page's heaviest work: a CSS animation
    // started then keeps its clock running while nothing is painted, and the shopper sees
    // only its last few frames. Arm the words once the page has loaded and the main thread
    // is idle, so the whole flight is drawn.
    whenSettled(function () {
      if (!('IntersectionObserver' in window)) {
        decorated.forEach(function (w) { w.classList.add('is-live'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-live');
            if (!repeat) io.unobserve(entry.target);
          } else if (repeat) {
            entry.target.classList.remove('is-live');
          }
        });
      }, { threshold: 0.6 });
      decorated.forEach(function (w) { io.observe(w); });
    });
  }

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
    else setTimeout(fn, 400);
  }

  function whenSettled(fn) {
    if (document.readyState === 'complete') whenIdle(fn);
    else window.addEventListener('load', function () { whenIdle(fn); }, { once: true });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-hle]').forEach(decorate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
